import * as u from "react";
import { useMemo as n, useCallback as h } from "react";
import { f as l, a as o, b as r, F as a, e as m, c as i } from "../../../filters-Cwo0Aj2k.js";
import { l as d } from "../../../lodash-DeBCDn4U.js";
function I(e, t) {
  return /* @__PURE__ */ u.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: t
  }, e), /* @__PURE__ */ u.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.228 9c.549-1.165 2.03-2 3.772-2 2.21 0 4 1.343 4 3 0 1.4-1.278 2.575-3.006 2.907-.542.104-.994.54-.994 1.093m0 3h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
  }));
}
const $ = u.forwardRef(I), k = (e) => n(() => l.get(e.predicate.negate ? o.negate : o.default) ?? $, [e.predicate.negate]), C = (e) => e.replaceAll("\\", "\\\\").replaceAll("%", "\\%").replaceAll("_", "\\_"), c = (e) => e.replaceAll("\\%", "%").replaceAll("\\_", "_").replaceAll("\\\\", "\\"), x = (e) => {
  switch (e.predicate.operator) {
    case r.IN:
      return e.predicate.value.entries.map((t) => t.id).join(", ");
    case r.Like: {
      const { pattern: t } = e.predicate.value;
      return p(t) ? c(t.substring(1, t.length - 1)) : T(t) ? c(t.substring(0, t.length - 1)) : c(t.substring(1, t.length));
    }
    case r.Match:
      return c(e.predicate.value.pattern);
    case r.BETWEEN:
      return "";
    case r.LT:
    case r.LTE:
    case r.GT:
    case r.EQ:
    case r.GTE:
      return "";
    default:
      return e.predicate;
  }
}, v = (e, t) => {
  switch (e.predicate.operator) {
    case r.IN:
      return e.predicate.value.entries.map((s) => s.id).join(", ");
    case r.Like: {
      const { pattern: s } = e.predicate.value;
      return p(s) ? `${t.get(`filter.type.${a.INCLUDE}.title`)}: ${c(s.substring(1, e.predicate.value.pattern.length - 1))}` : T(s) ? `${t.get(`filter.type.${a.START_WITH}.title`)}: ${c(s.substring(0, e.predicate.value.pattern.length - 1))}` : E(s) ? `${t.get(`filter.type.${a.END_WITH}.title`)}: ${c(s.substring(1, e.predicate.value.pattern.length))}` : s;
    }
    case r.Match:
      return `${t.get(`filter.operator.${r.Match}`)}: ${c(e.predicate.value.pattern)}`;
    case r.BETWEEN:
      return `${t.get(`filter.operator.${r.BETWEEN}`, {
        min: e.predicate.value.minInclusive,
        max: e.predicate.value.maxInclusive
      })}`;
    case r.GT:
      return `${t.get(`filter.operator.${r.GT}`, e.predicate.value.value)}`;
    case r.EQ:
      return `${t.get(`filter.operator.${r.EQ}`, e.predicate.value.value)}`;
    case r.GTE:
      return `${t.get(`filter.operator.${r.GTE}`, e.predicate.value.value)}`;
    case r.LTE:
      return `${t.get(`filter.operator.${r.LTE}`, e.predicate.value.value)}`;
    case r.LT:
      return `${t.get(`filter.operator.${r.LT}`, e.predicate.value.value)}`;
    default:
      return e.predicate;
  }
}, y = (e, t) => n(() => v(e, t), [e, t]), G = (e, t) => n(() => m[e.type === i.metric ? "metric" : e.dataType].map(
  (s) => ({
    label: t.get(`filter.type.${s}.title`),
    value: s
  })
), [e.dataType, e.type, t]), W = (e) => {
  try {
    return RegExp(e), !0;
  } catch {
    return !1;
  }
}, b = (e, t) => n(() => {
  switch (e) {
    case a.REGEX:
      return W(t);
    default:
      return !0;
  }
}, [t, e]), w = (e) => n(() => e ? !isNaN(Number(e)) : !0, [e]), F = (e, t) => n(() => !d.isEmpty(e) && !d.isEmpty(t) ? Number(e) < Number(t) : !0, [e, t]), _ = (e) => {
  switch (e.predicate.operator) {
    case r.IN:
      return e.predicate.value.entries.length === 0;
    case r.Like:
    case r.Match:
      return !e.predicate.value.pattern.replaceAll("%", "").trim();
    case r.BETWEEN:
      return e.predicate.value.maxInclusive === void 0 || e.predicate.value.minInclusive === void 0;
    case r.GT:
    case r.EQ:
    case r.GTE:
    case r.LTE:
    case r.LT:
      return e.predicate.value.value === null || e.predicate.value.value === void 0;
    default:
      return e;
  }
}, A = (e) => h((t, s = e) => {
  switch (s) {
    case a.INCLUDE:
      return `%${t === "" ? " " : t}%`;
    case a.END_WITH:
      return `%${t === "" ? " " : t}`;
    case a.START_WITH:
      return `${t === "" ? " " : t}%`;
    default:
      return t;
  }
}, [e]), p = (e) => e.startsWith("%") && e.endsWith("%") && !(e.startsWith("\\%") || e.endsWith("\\%")), E = (e) => e.startsWith("%") && !e.startsWith("\\%"), T = (e) => e.endsWith("%") && !e.endsWith("\\%"), f = () => h((e) => {
  switch (e.predicate.operator) {
    case r.IN:
      return a.VALUE_SELECTION;
    case r.Like:
      return p(e.predicate.value.pattern) ? a.INCLUDE : E(e.predicate.value.pattern) ? a.END_WITH : a.START_WITH;
    case r.Match:
      return a.REGEX;
    case r.BETWEEN:
      return a.BETWEEN;
    case r.GT:
      return a.GREATER;
    case r.EQ:
      return a.EQUAL;
    case r.GTE:
      return a.GREATER_OR_EQ;
    case r.LTE:
      return a.LOWER_OR_EQ;
    case r.LT:
      return a.LOWER;
    default:
      return e.predicate;
  }
}, []), M = (e) => n(() => e.length > 0 && (e.startsWith(" ") || e.endsWith(" ")), [e]), O = (e, t) => {
  switch (e.type) {
    case i.dimension:
      return t;
    case i.metric:
      return e.reference.asPercentage ? t === void 0 ? t ?? void 0 : Number(t) * 100 : t;
    default:
      return e;
  }
}, Q = (e, t) => {
  switch (e.type) {
    case i.dimension:
      return t;
    case i.metric:
      return e.reference.asPercentage ? t === void 0 ? t ?? void 0 : t / 100 : t;
    default:
      return e;
  }
};
export {
  C as escapePattern,
  O as formatFilterValueToHumanReadable,
  Q as formatFilterValueToLego,
  v as getFilterResume,
  x as getFilterValue,
  E as isEndWithPattern,
  _ as isFilterEmpty,
  p as isIncludePattern,
  W as isRegexValid,
  T as isStartWithPattern,
  c as unescapePattern,
  k as useCurrentIcon,
  G as useFilterTypeOptions,
  y as useFilterValue,
  f as useGetFilterType,
  A as useGetFilterValue,
  M as useIsFilterContainingLeadingOrTrailingSpace,
  b as useIsFilterValueValid,
  F as useIsMinUnderMax,
  w as useIsValueNumeric
};
//# sourceMappingURL=utils.js.map
